import Provider from "../Provider";
import TypeVehicleContextType from "./TypeVehicleContextType";

export default interface TypeVehicleProvider extends Provider<TypeVehicleContextType> {
    
}

export const TypeVehicleProviderName = "TypeVehicleProvider";